import { render, staticRenderFns } from "./AddToCollectionAction.vue?vue&type=template&id=62f7f53f"
import script from "./AddToCollectionAction.vue?vue&type=script&lang=ts"
export * from "./AddToCollectionAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports